import { Controller } from "stimulus";
import flatpickr from 'flatpickr';
import MitreTable from "../utils/mitre-table";

class RangeFilter extends Controller {
  static targets = [
    'rangeSelector',
    'rangeContainer',
    'rangeButton',
    'fromVal',
    'toVal',
    'fromClearVal',
    'toClearVal'
  ];

  static values = {
    key: String,
    type: String,
  };

  initialize() {
    this.filterKey = this.keyValue;
    this.filterType = this.typeValue;
    this.flatpickrSelectors = {};
    this.targetMapping = {
      fromVal: `${this.filterKey}_from`,
      toVal: `${this.filterKey}_to`
    };
    this.prevDecimalInput = '';
    this.decimalRegex = /^-?\d+(\.\d{0,1})?$/;
  }

  connect() {
    const tableKey = this.element.closest('[data-table-key-value]').getAttribute('data-table-key-value');
    this._mitreTable = MitreTable.getByTableKey(tableKey);

    if(this.filterType == "decimal") {
      this.fromValTarget.setAttribute('data-action', 'input->range-filter#decimalInput');
      this.toValTarget.setAttribute('data-action', 'input->range-filter#decimalInput');
    } else {
      this.fromValTarget.setAttribute('readonly', 'readonly');
      this.toValTarget.setAttribute('readonly', 'readonly');

      this.dateInput();
    }

    this._mitreTable.on('reset_filters', () => {
      for (let el in this.flatpickrSelectors) {
        this.flatpickrSelectors[el].clear();
      };

      this.fromValTarget.value = '';
      this.toValTarget.value = '';

      this.__setButtonState(false);
    });
  }

  dateInput() {
    const _targetMapping = this.targetMapping;
    const _filterType = this.filterType;
    const _buttonState = (state) => {
      this.__setButtonState(state);
    }

    for (let el in _targetMapping) {
      let flatpickrSelector = flatpickr(this[`${el}Target`], {
        dateFormat: 'Y-m-d',
        disableMobile: true,
        onChange: function(selectedDates) {
          const [selectedDate] = selectedDates;
          _buttonState(selectedDate ? true : false);
          if (selectedDate) {
            const timestamp = selectedDate.valueOf();

            if (this.element.nextElementSibling.classList.contains('t-opacity-0')) {
              this.element.nextElementSibling.classList.remove('t-opacity-0');
            }

            EventManager.emit('update_filter', {
              filterKey: _targetMapping[el],
              selected: false,
              value: timestamp,
              type: _filterType
            });
          }
        }
      });

      this.flatpickrSelectors[el] = flatpickrSelector;
    }
  }

  decimalInput(e) {
    e.preventDefault();
    let inputSelection = e.currentTarget;
    let currentTarget = inputSelection.getAttribute('data-range-filter-target');

    if(inputSelection.value !== "-" && inputSelection.value !== "") {
      let inputValue = parseFloat(inputSelection.value);

      if(isNaN(inputValue)) {
        inputSelection.value = "";
        inputValue = null;
      }

      if(this.decimalRegex.test(inputValue) || inputValue === 0){
        this.prevDecimalInput = inputValue;

        EventManager.emit('update_filter', {
          filterKey: this.targetMapping[currentTarget],
          selected: false,
          value: inputValue,
          type: this.filterType
        });
      } else {
        inputSelection.value = this.prevDecimalInput;
      }
    } else {
      EventManager.emit('update_filter', {
        filterKey: this.targetMapping[currentTarget],
        selected: false,
        value: null,
        type: this.filterType
      });
    }

    this.__setButtonState(this.fromValTarget.value !== '' || this.toValTarget.value !== '');
  }

  closeState() {
    setTimeout(() => {
      let hideSelector = true;
      let selectors = ['rangeSelector', 'fromVal', 'toVal', 'fromClearVal', 'toClearVal'];

      for(let selector of selectors) {
        if(this.element.querySelector(`[data-range-filter-target="${selector}"]`) === document.activeElement) {
          hideSelector = false;
          break;
        }
      }

      for(let calendarItem of document.getElementsByClassName('flatpickr-calendar')) {
        if(calendarItem === document.activeElement) {
          hideSelector = false;
          break;
        }
      }

      if (!this.rangeSelectorTarget.classList.contains('t-hidden') && hideSelector) {
        this.rangeSelectorTarget.classList.add('t-hidden');
      }
    }, 10);
  }

  popupStatus(e) {
    e.stopPropagation();

    if (this.rangeSelectorTarget.classList.contains('t-hidden')) {
      this.rangeSelectorTarget.classList.remove('t-hidden');
    } else {
      this.rangeSelectorTarget.classList.add('t-hidden');
    }

    EventManager.emit('scroll_container', {
      selector: this.rangeSelectorTarget,
      container: this.rangeContainerTarget
    });
  }

  clearDateField(e) {
    e.stopPropagation();
    let element = e.currentTarget.previousElementSibling.getAttribute('data-range-filter-target');
    e.currentTarget.classList.add('t-opacity-0');
    this.flatpickrSelectors[element].clear();

    EventManager.emit('update_filter', {
      filterKey: this.targetMapping[element],
      selected: false,
      value: null,
      type: this.filterType
    });

    this.__setButtonState(this.fromValTarget.value !== '' || this.toValTarget.value !== '');
  }

  __setButtonState(state) {
    EventManager.emit('filter_button_state', {
      element: this.rangeButtonTarget,
      state: state
    });
  }
}

export default RangeFilter;
